export const getDragColors = (isDragging, theme) => {
  const colors = theme && theme.colors ? theme.colors : { 
    brand: { primary: '#0056b3' },
    surface: { muted: '#f8f9fa', base: '#ffffff' },
    border: '#dee2e6',
    text: { primary: '#212529' }
  };

  if (isDragging) {
    return {
      bg: `${colors.brand.primary}15`,
      border: colors.brand.primary,
      text: colors.brand.primary
    };
  }

  return {
    bg: colors.surface.muted || '#f8f9fa',
    border: colors.border || '#dee2e6',
    text: colors.text.primary || '#212529'
  };
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};



// WEBPACK FOOTER //
// ./src/design-system/molecules/DragAndDrop/utils/dragAndDropHelpers.js